// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__mgK+b","header":"styles_header__W0Mbj"};